import React, { useState } from "react";
import useDebouncedSearch from "hooks/useDebouncedSearch";
import { useTranslation } from "react-i18next";
import { TablePage } from "@outpave/ds";
import StatementsTable from "../../components/admin/statements/StatementsTable";

export const STATEMENTS_TABS = {
  STATEMENTS: { id: "statements", label: "Statements" },
};

const Statements: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const search = useDebouncedSearch(setSearchTerm);

  const tabConfigurations = [STATEMENTS_TABS.STATEMENTS];

  return (
    <TablePage
      title={t("Statements")}
      tabs={{
        items: tabConfigurations.map((tab, index) => ({
          id: String(index),
          label: t(tab.label),
        })),
        activeId: String(activeTab),
        onChange: (id) => setActiveTab(Number(id)),
      }}
      search={search}
    >
      <StatementsTable searchTerm={searchTerm} />
    </TablePage>
  );
};

export default Statements;
